import axios from 'axios';

import { getApiBaseUrl } from './platform';

const baseURL = getApiBaseUrl();
console.log('API Service Base URL:', baseURL);

const api = axios.create({
  baseURL,
  timeout: 30000 // 30 second timeout for all requests
});

// Track if we're showing the "server starting" message
let serverStartingNotified = false;

// Response interceptor to handle 503 (Service Unavailable) with automatic retry
api.interceptors.response.use(
  (response) => {
    // Clear the notification flag on successful response
    if (serverStartingNotified) {
      serverStartingNotified = false;
      console.log('Server is now ready');
    }
    return response;
  },
  async (error) => {
    const config = error.config;

    // Handle 503 Service Unavailable (server starting up)
    if (error.response?.status === 503) {
      // Only retry once per request
      if (!config._retry503) {
        config._retry503 = true;

        // Log once that server is starting
        if (!serverStartingNotified) {
          serverStartingNotified = true;
          console.log('Server is starting up, will retry in a few seconds...');
        }

        // Get retry delay from header or default to 5 seconds
        const retryAfter = parseInt(error.response.headers['retry-after'] || '5', 10);
        const delayMs = retryAfter * 1000;

        // Wait and retry
        await new Promise(resolve => setTimeout(resolve, delayMs));
        return api(config);
      }
    }

    // For all other errors, reject as normal
    return Promise.reject(error);
  }
);

export default api;